import { 
  doc, 
  setDoc, 
  getDoc, 
  collection,
  query,
  where,
  getDocs,
  runTransaction,
  updateDoc
} from 'firebase/firestore';
import { db } from './firebase-config';
import { Customer, Visit } from '../types';

export const saveCustomer = async (establishmentId: string, customerData: Partial<Customer>): Promise<string> => {
  try {
    if (!customerData.phone) {
      throw new Error('Telefone é obrigatório');
    }

    const customersRef = collection(db, `establishments/${establishmentId}/customers`);
    const customerDoc = doc(customersRef);
    const customerId = customerDoc.id;
    
    const now = new Date().toISOString();
    
    const newCustomer = {
      ...customerData,
      id: customerId,
      establishmentId,
      createdAt: now,
      birthDate: customerData.birthDate,
      totalVisits: 0,
      visits: [],
      points: 0
    };

    await setDoc(customerDoc, newCustomer);
    return customerId;
  } catch (error: any) {
    console.error('Save customer error:', error);
    throw new Error(error.message || 'Erro ao salvar cliente');
  }
};

export const getCustomer = async (establishmentId: string, phone: string): Promise<Customer | null> => {
  try {
    const customersRef = collection(db, `establishments/${establishmentId}/customers`);
    const q = query(customersRef, where('phone', '==', phone));
    const snapshot = await getDocs(q);
    
    if (!snapshot.empty) {
      const customerDoc = snapshot.docs[0];
      const data = customerDoc.data();
      if (data.establishmentId === establishmentId) {
        return {
          ...data,
          id: customerDoc.id,
          createdAt: data.createdAt || new Date().toISOString(),
          birthDate: data.birthDate || null,
          lastVisit: data.lastVisit || null
        } as Customer;
      }
    }
    return null;
  } catch (error: any) {
    console.error('Get customer error:', error);
    throw new Error(error.message || 'Erro ao buscar cliente');
  }
};

export const getEstablishmentCustomers = async (establishmentId: string): Promise<Customer[]> => {
  try {
    const customersRef = collection(db, `establishments/${establishmentId}/customers`);
    const snapshot = await getDocs(customersRef);
    
    return snapshot.docs
      .map(doc => {
        const data = doc.data();
        return {
          ...data,
          id: doc.id,
          createdAt: data.createdAt || new Date().toISOString(),
          birthDate: data.birthDate || null,
          lastVisit: data.lastVisit || null
        } as Customer;
      })
      .filter(customer => customer.establishmentId === establishmentId)
      .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
  } catch (error: any) {
    console.error('Get establishment customers error:', error);
    throw new Error(error.message || 'Erro ao buscar clientes');
  }
};

export const updateCustomerPoints = async (establishmentId: string, phone: string, points: number): Promise<void> => {
  try {
    const customer = await getCustomer(establishmentId, phone);
    if (!customer) {
      throw new Error('Cliente não encontrado');
    }

    const customerRef = doc(db, `establishments/${establishmentId}/customers/${customer.id}`);
    await updateDoc(customerRef, { points });
  } catch (error: any) {
    console.error('Update customer points error:', error);
    throw new Error(error.message || 'Erro ao atualizar pontos');
  }
};